{
	"resourceType": "Questionnaire",
	"meta": {
		"profile": ["http://hl7.org/fhir/4.0/StructureDefinition/Questionnaire"]
	},
	"url": "http://reference-data.careconnect.be/api/fhir/Questionnaire/MMSE",
	"name": "MMSE",
	"language": "nl-BE",
	"status": "active",
	"publisher": "Corilus NV",
	"title": "Mini-Mental State Examination",
	"purpose": "Meet het cognitief functioneren",
	"description": "De MMSE bestaat uit twee onderdelen. Het eerste deel vereist mondelinge antwoorden en de maximale score bedraagt 21. Het tweede deel van de test vereist lezen en schrijven. Mensen met gezichtsproblemen kunnen bij dit deel problemen ondervinden. De maximale score van het tweede deel is 9. De maximumscore is 30. Een score onder 24 wijst op een cognitieve stoornis (5 % fout-negatieven).",
	"item": [
		{
			"linkId": "mmse-instructions",
			"text": "Stel de vragen aan de patiënt in de opgegeven volgorde. Neem de tijd en moedig de patiënt aan, maar geef geen hints.",
			"type": "display"
		},
		{
			"linkId": "40100",
			"text": "Oriëntatie - Tijd",
			"type": "group",
			"item": [
				{
					"linkId": "mmse-orientation-time-display",
					"text": "Vraag de datum. Vraag daarna specifiek naar weggelaten onderdelen.",
					"type": "display"
				},
				{
					"linkId": "40200",
					"text": "Welk jaar is het?",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "40201",
								"display": "Correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "40202",
								"display": "Niet correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "40300",
					"text": "Welk seizoen is het?",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "40301",
								"display": "Correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "40302",
								"display": "Niet correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "40400",
					"text": "Welke datum is het vandaag?",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "40401",
								"display": "Correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "40402",
								"display": "Niet correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "40500",
					"text": "Welke dag van de week is het?",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "40501",
								"display": "Correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "40502",
								"display": "Niet correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "40600",
					"text": "Welke maand is het?",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "40601",
								"display": "Correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "40602",
								"display": "Niet correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				}
			]
		},
		{
			"linkId": "40700",
			"text": "Oriëntatie - Plaats",
			"type": "group",
			"item": [
				{
					"linkId": "mmse-orientation-place-display",
					"text": "Vraag: \"Kunt u mij de naam van deze plaats vertellen?\" Vraag daarna specifiek naar weggelaten onderdelen.",
					"type": "display"
				},
				{
					"linkId": "40800",
					"text": "In welk land zijn we?",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "40801",
								"display": "Correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "40802",
								"display": "Niet correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "40900",
					"text": "In welke stad zijn we?",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "40901",
								"display": "Correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "40902",
								"display": "Niet correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "41000",
					"text": "In welk stadsdeel zijn we?",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "41001",
								"display": "Correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "41002",
								"display": "Niet correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "41100",
					"text": "Wat is het huisnummer of verdieping?",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "41101",
								"display": "Correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "41102",
								"display": "Niet correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "41200",
					"text": "Wat is de naam van de straat?",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "41201",
								"display": "Correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "41202",
								"display": "Niet correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				}
			]
		},
		{
			"linkId": "41300",
			"text": "Registratie",
			"type": "group",
			"item": [
				{
					"linkId": "mmse-registration-display",
					"text": "Noem de namen van drie niet-gerelateerde objecten, duidelijk en langzaam. Vraag de patiënt na het noemen van alle drie om ze te herhalen. Zorg ervoor dat de patiënt alle drie woorden kent voor de latere herinneringsvraag.",
					"type": "display"
				},
				{
					"linkId": "41400",
					"text": "Wat is het eerste woord?",
					"type": "string",
					"required": true
				},
				{
					"linkId": "41500",
					"text": "Wat is het tweede woord?",
					"type": "string",
					"required": true
				},
				{
					"linkId": "41600",
					"text": "Wat is het derde woord?",
					"type": "string",
					"required": true
				},
				{
					"linkId": "41700",
					"text": "Was het eerste woord correct herhaald?",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "41701",
								"display": "Correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "41702",
								"display": "Niet correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "41800",
					"text": "Was het tweede woord correct herhaald?",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "41801",
								"display": "Correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "41802",
								"display": "Niet correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "41900",
					"text": "Was het derde woord correct herhaald?",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "41901",
								"display": "Correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "41902",
								"display": "Niet correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				}
			]
		},
		{
			"linkId": "42000",
			"text": "Aandacht en rekenvaardigheid",
			"type": "group",
			"item": [
				{
					"linkId": "mmse-attention-display",
					"text": "Vraag de patiënt om bij 100 te beginnen en telkens 7 af te trekken. Stop na vijf aftrekkingen (93, 86, 79, 72, 65). Als de patiënt deze taak niet kan of wil uitvoeren, vraag hem/haar om een woord met 5 verschillende letters (zoals 'dorst') achterstevoren te spellen.",
					"type": "display"
				},
				{
					"linkId": "42100",
					"text": "Welke test wilt u gebruiken voor de aandacht en rekenvaardigheid?",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "42101",
								"display": "Rekenvaardigheid"
							}
						},
						{
							"valueCoding": {
								"code": "42102",
								"display": "Spelling"
							}
						}
					]
				},
				{
					"linkId": "42200",
					"text": "Rekenvaardigheid",
					"type": "group",
					"enableWhen": [
						{
							"question": "42100",
							"operator": "=",
							"answerCoding": {
								"code": "42101"
							}
						}
					],
					"item": [
						{
							"linkId": "42300",
							"text": "Hoeveel cijfers heeft de patiënt juist benoemd? (max. 5)",
							"type": "integer",
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/minValue",
									"valueInteger": 0
								},
								{
									"url": "http://hl7.org/fhir/StructureDefinition/maxValue",
									"valueInteger": 5
								}
							],
							"required": true
						}
					]
				},
				{
					"linkId": "42800",
					"text": "Spelling test",
					"type": "group",
					"enableWhen": [
						{
							"question": "42100",
							"operator": "=",
							"answerCoding": {
								"code": "42102"
							}
						}
					],
					"item": [
						{
							"linkId": "42900",
							"text": "Typ het gekozen woord.",
							"type": "string",
							"required": true
						},
						{
							"linkId": "43000",
							"text": "Hoeveel letters heeft de patiënt juist benoemd? (max. 5)",
							"type": "integer",
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/minValue",
									"valueInteger": 0
								},
								{
									"url": "http://hl7.org/fhir/StructureDefinition/maxValue",
									"valueInteger": 5
								}
							],
							"required": true
						}
					]
				}
			]
		},
		{
			"linkId": "43500",
			"text": "Herinnering",
			"type": "group",
			"item": [
				{
					"linkId": "mmse-recall-display",
					"text": "Vraag de patiënt of hij/zij de drie woorden kan herinneren die eerder gevraagd werden.",
					"type": "display"
				},
				{
					"linkId": "43600",
					"text": "Was het eerste woord correct herhaald?",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "43601",
								"display": "Correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "43602",
								"display": "Niet correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "43700",
					"text": "Was het tweede woord correct herhaald?",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "43701",
								"display": "Correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "43702",
								"display": "Niet correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "43800",
					"text": "Was het derde woord correct herhaald?",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "43801",
								"display": "Correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "43802",
								"display": "Niet correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				}
			]
		},
		{
			"linkId": "43900",
			"text": "Taal",
			"type": "group",
			"item": [
				{
					"linkId": "mmse-language-display",
					"text": "Beoordeelt benoeming, herhaling, het opvolgen van opdrachten, lezen, schrijven en kopiëren.",
					"type": "display"
				},
				{
					"linkId": "44000",
					"text": "Toon de patiënt een polshorloge en vraag wat het is.",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "44001",
								"display": "Correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "44002",
								"display": "Niet correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "44100",
					"text": "Toon de patiënt een potlood en vraag wat het is.",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "44101",
								"display": "Correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "44102",
								"display": "Niet correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "44200",
					"text": "Vraag de patiënt om de volgende zin na te zeggen (slechts één poging): \"geen alsen, ennen of maren.\"",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "44201",
								"display": "Correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "44202",
								"display": "Niet correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "44300",
					"text": "Neem een papier in uw rechterhand.",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "44301",
								"display": "Correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "44302",
								"display": "Niet correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "44400",
					"text": "Vouw het papier doormidden.",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "44401",
								"display": "Correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "44402",
								"display": "Niet correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "44500",
					"text": "Leg het papier op de grond.",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "44501",
								"display": "Correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "44502",
								"display": "Niet correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "44600",
					"text": "Schrijf op een blanco vel in grote letters \"Sluit uw ogen\". Vraag de patiënt om het te lezen en te doen wat er staat.",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "44601",
								"display": "Correct uitgevoerd"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "44602",
								"display": "Niet correct uitgevoerd"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "44700",
					"text": "Geef de patiënt een blanco vel en vraag hem/haar een zin te schrijven. Dicteer geen zin; de zin moet spontaan geschreven worden.",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "44701",
								"display": "Schrijft een begrijpelijke zin met onderwerp en werkwoord"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "44702",
								"display": "Niet in staat om een zin te schrijven"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "44800",
					"text": "Teken twee overlappende vijfhoeken (elke zijde ca. 2,5 cm) op een blanco vel en vraag de patiënt om ze exact na te tekenen.",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "44801",
								"display": "Correct gekopieerd (twee vijfhoeken met overlapping)"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "44802",
								"display": "Niet correct gekopieerd"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				}
			]
		}
	]
}
